import React from 'react';

export default function RebatePrograms() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-5 w-full">
      <div className="col-span-1"></div>
      <div className="col-span-4 mx-auto py-14 bg-white">
        <h1 className="text-4xl mb-6 tracking-wide">Rebate Programs</h1>
        <p className="text-sm mb-10 mt-8 w-4/5 leading-relaxed">
          The table below shows the rebate programs Anacle offers.
        </p>

        <div className="overflow-x-auto">
          <table className="w-full table-fixed text-sm leading-loose">
            <thead>
              <tr className="text-left text-[#BF984D] border-b border-gray-700 text-base">
                <th className="w-1/2"></th>
                <th className="w-2/6 text-center">Preferred</th>
                <th className="w-2/6 text-center">Exclusive</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-gray-200">
                <td className="py-6 text-[#BF984D] font-medium text-lg">
                  Sales Target (6 months)
                </td>
                <td className="text-center py-6">
                  SGD 100,000<sup>*</sup> or equivalent
                </td>
                <td className="text-center py-6">
                  SGD 250,000<sup>*</sup> or equivalent
                </td>
              </tr>

              <tr className="border-b border-gray-200 align-top">
                <td className="py-6 text-[#BF984D] font-medium text-lg">
                  Rebate %
                </td>
                <td className="text-center py-6 space-y-6 px-4">
                  <div>
                    <span className="font-semibold text-[#BF984D]">
                      3% Rebate
                    </span>
                    <br />
                    <span className="text-sm">
                      Order Book achievement of above
                      <br />
                      SGD 100,000<sup>*</sup> to SGD 250,000<sup>*</sup>
                    </span>
                  </div>
                  <div>
                    <span className="font-semibold text-[#BF984D]">
                      5% Rebate
                    </span>
                    <br />
                    <span className="text-sm">
                      Order Book achievement of above
                      <br />
                      SGD 250,000<sup>*</sup>
                    </span>
                  </div>
                </td>
                <td className="text-center py-6 space-y-6 px-4">
                  <div>
                    <span className="font-semibold text-[#BF984D]">
                      5% Rebate
                    </span>
                    <br />
                    <span className="text-sm">
                      Order Book achievement of above
                      <br />
                      SGD 250,000<sup>*</sup> to SGD 500,000<sup>*</sup>
                    </span>
                  </div>
                  <div>
                    <span className="font-semibold text-[#BF984D]">
                      7% Rebate
                    </span>
                    <br />
                    <span className="text-sm">
                      Order Book achievement of above
                      <br />
                      SGD 500,000<sup>*</sup>
                    </span>
                  </div>
                </td>
              </tr>

              <tr className="border-b border-gray-200">
                <td className="py-6 text-[#BF984D] font-medium text-lg">
                  Qualifying Periods
                </td>
                <td className="text-center py-6">
                  June to November
                  <br />
                  December to May
                </td>
                <td className="text-center py-6">
                  June to November
                  <br />
                  December to May
                </td>
              </tr>

              <tr className="">
                <td className="py-6 text-[#BF984D] font-medium text-lg">
                  Pay-out Periods
                </td>
                <td className="text-center py-6">January and July</td>
                <td className="text-center py-6">January and July</td>
              </tr>
            </tbody>
          </table>
        </div>

        <p className="text-xs mt-8 text-gray-500 w-4/5 leading-relaxed mb-10">
          *Anacle’s Rebate Programs are offered only to Preferred and Exclusive
          Partners. Authorized Partners will not be eligible.
        </p>
      </div>
    </div>
  );
}
